var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    staticClass: "modal",
    attrs: {
      "id": _vm.id,
      "title": _vm.title,
      "hide-footer": !_vm.customFooter,
      "hide-header": "",
      "size": _vm.size,
      "no-close-on-backdrop": _vm.closeDisabled,
      "no-close-on-esc": _vm.closeDisabled
    },
    on: {
      "hidden": _vm.onHidden
    },
    scopedSlots: _vm._u([_vm.customFooter ? {
      key: "modal-footer",
      fn: function () {
        return [_c('b-button', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.onSubmit
          }
        }, [_vm._v(" " + _vm._s(_vm.$t(_vm.buttonLanguageKey)) + " ")]), _c('b-button', {
          on: {
            "click": _vm.onClose
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('close')) + " ")])];
      },
      proxy: true
    } : null], null, true)
  }, [_c('div', {
    class: [{
      'modal-body-inner': _vm.size === 'lg'
    }, _vm.bodyClass]
  }, [_c('modal-header', {
    attrs: {
      "title": _vm.title,
      "close-disabled": _vm.closeDisabled
    },
    on: {
      "close": _vm.onClose
    }
  }), _vm._t("body")], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }